/*
  Oneindige teamslider op de over-onspagina.

  Werking: de reeks staat drie keer achter elkaar. We beginnen in het
  middelste blok, zodat er aan beide kanten al kaarten staan. Zodra de
  bezoeker voorbij de rand van dat blok scrollt, verspringt de positie
  onzichtbaar een set terug -- de kaart onder de cursor blijft dus op
  zijn plek staan en het lijkt of de reeks doorloopt.

  Twee dingen die hierbij misgaan als je ze vergeet:
  - scroll-snap moet uit. Die vecht met de sprong: de browser probeert
    tijdens het herpositioneren terug te snappen, wat een zichtbare
    stuiter geeft.
  - de klonen moeten lazy laden. Zonder dat haalt de pagina drie keer
    zoveel foto's op als er zichtbaar zijn.
*/
(function () {
  var sliders = document.querySelectorAll('[data-oo-slider]');
  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    var spoor = slider.querySelector('[data-oo-spoor]');
    if (!spoor) return;

    var origineel = Array.prototype.slice.call(spoor.children);
    var aantal = origineel.length;
    if (aantal < 2) return;

    function maakSet() {
      var fragment = document.createDocumentFragment();
      origineel.forEach(function (kaart) {
        var kloon = kaart.cloneNode(true);
        kloon.setAttribute('aria-hidden', 'true');
        kloon.querySelectorAll('img').forEach(function (img) {
          img.setAttribute('loading', 'lazy');
        });
        kloon.querySelectorAll('a, button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        fragment.appendChild(kloon);
      });
      return fragment;
    }

    // Twee extra sets: een ervoor en een erna. De set ervoor gaat als
    // fragment naar voren -- kaart voor kaart met insertBefore(firstChild)
    // zet de reeks achterstevoren, en dan zie je bij terugscrollen het
    // team in omgekeerde volgorde.
    spoor.insertBefore(maakSet(), spoor.firstChild);
    spoor.appendChild(maakSet());

    var setBreedte = 0;
    var springt = false;

    function meet() {
      // Niet scrollWidth / 3: daar zit de padding van het spoor in, en die
      // hoort maar een keer bij het totaal. Dan valt de sprong te kort uit
      // en schuift de reeks elke ronde een stukje op. De afstand tussen de
      // eerste kaart van set 1 en die van set 2 is per definitie exact een
      // set breed.
      var kaarten = spoor.children;
      if (kaarten.length < aantal * 2) return;
      setBreedte = kaarten[aantal].offsetLeft - kaarten[0].offsetLeft;
    }

    function naarMidden() {
      meet();
      spoor.scrollLeft = setBreedte;
    }

    function bewaak() {
      if (springt || !setBreedte) return;
      var x = spoor.scrollLeft;
      if (x < setBreedte * 0.5) {
        springt = true;
        spoor.scrollLeft = x + setBreedte;
        springt = false;
      } else if (x > setBreedte * 1.5) {
        springt = true;
        spoor.scrollLeft = x - setBreedte;
        springt = false;
      }
    }

    function stap(richting) {
      var kaart = spoor.querySelector('li');
      if (!kaart) return;
      var breedte = kaart.getBoundingClientRect().width;
      var gat = parseFloat(getComputedStyle(spoor).columnGap || '0') || 0;
      spoor.scrollBy({ left: richting * (breedte + gat), behavior: 'smooth' });
    }

    var vorige = slider.querySelector('[data-oo-vorige]');
    var volgende = slider.querySelector('[data-oo-volgende]');
    if (vorige) vorige.addEventListener('click', function () { stap(-1); });
    if (volgende) volgende.addEventListener('click', function () { stap(1); });

    spoor.addEventListener('scroll', bewaak, { passive: true });
    window.addEventListener('resize', naarMidden);

    // Na het laden van de beelden kan de setbreedte nog verschuiven.
    naarMidden();
    window.addEventListener('load', naarMidden);
  });
})();
